<template>
  <main class="create-customer-page">
    <header>
      <router-link :to="toCustomers">← Customers</router-link>
      <h1>Add customer</h1>
      <p>Create the company and its first user. Fields marked * are required.</p>
    </header>
    <CreateCustomerForm :route-after-save="toCustomers" />
  </main>
</template>
<script setup lang="ts">
import { STAFF_CUSTOMERS_LIST } from '@/types/router'
import CreateCustomerForm from '@/views/Components/Customer/CreateCustomerForm.vue'
const toCustomers = { name: STAFF_CUSTOMERS_LIST }
</script>
<style scoped>
.create-customer-page {
  max-width: 1120px;
  margin: 0 auto;
  padding: 24px 0;
}
header {
  margin-bottom: 24px;
}
header a {
  display: inline-block;
  margin-bottom: 16px;
}
h1 {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 8px;
}
p {
  color: var(--bs-secondary-color, #596560);
  margin: 0;
}
</style>
